import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "container",
  id: "container"
}
const _hoisted_2 = {
  key: 0,
  class: "atlas__message",
  role: "alert"
}
const _hoisted_3 = { class: "action-buttons" }
const _hoisted_4 = { class: "action-buttons__table-actions action-buttons__table-actions--inline" }
const _hoisted_5 = { class: "action-buttons__map-view" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "action-buttons__table-actions action-buttons__table-actions--stacked" }

import { computed } from 'vue';
import ResultCardList from '@/components/resultcard/ResultCardList.vue';
import ResultTable from '@/components/resulttable/ResultTable.vue';
import { columnConfig } from '@/interfaces/search/IQueryColumn';
import ColumnPicker from '@/components/columnpicker/ColumnPicker.vue';
import ColumnSort from '@/components/columnsort/ColumnSort.vue';
import Filter from '@/components/filter/Filter.vue';
import MapBox from '@/components/map/MapBox.vue';
import { useStore } from "@/stores/store";
import { useFilterStore } from "@/stores/filterStore";
import { ISearchResultItem } from '@/interfaces/search/ISearchResultItem';
import { useUtil } from '@/services/util-service';
import "../../node_modules/mapbox-gl/dist/mapbox-gl.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'Atlas',
  setup(__props) {

const store = useStore();
const filterStore = useFilterStore();
const hasFilter = computed(() => store.originalSearchResult?.results.length > 0);
const geojson = computed(() => {
  return createGeoJSONFromSearchResults(store.searchResult?.results)
});

function changeVersion(bool: boolean) {
  store.mapVersion = bool;
};

function saveToExcel(data) {
  useUtil().exportToExcel(data);
}

function createGeoJSONFromSearchResults(items: ISearchResultItem[] | undefined) {
  if (!items) {
    return;
  }

  const features = items?.filter((item: ISearchResultItem) => item.latitude != null && item.longitude != null)
    .map((item: ISearchResultItem) => {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [item.longitude, item.latitude]
        },
        properties: {
          id: item.uuid,
          icon: "custom-marker"
        }
      };
    });

  return {
    type: 'FeatureCollection',
    features: features
  };
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["atlas", { 'atlas--filter-open': hasFilter.value && _unref(filterStore).filterPanelOpen, 'atlas--filter-collapsed': hasFilter.value && !_unref(filterStore).filterPanelOpen, 'atlas--map-view': _unref(store).mapVersion, 'atlas--list-view': !_unref(store).mapVersion }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(store).apiErrorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(store).apiErrorMessage), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createVNode(Filter),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ColumnSort, { radioName: "sort-by-inline" }),
          _createVNode(ColumnPicker, {
            "id-prefix": "column-picker-inline",
            columnConfig: _unref(columnConfig)
          }, null, 8 /* PROPS */, ["columnConfig"]),
          _createElementVNode("button", {
            class: "button button--filter download-result",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (saveToExcel(_unref(store).searchResult?.results)))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("span", null, "Ladda ner", -1 /* HOISTED */),
            _createElementVNode("span", { class: "icon icon--download" }, null, -1 /* HOISTED */)
          ]))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "button button--filter",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeVersion(true)))
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "icon icon--earth" }, null, -1 /* HOISTED */)),
            _createElementVNode("span", null, "Kartvy (" + _toDisplayString(_unref(store).numResultWithCoordinates) + ")", 1 /* TEXT */)
          ]),
          _createElementVNode("button", {
            class: "button button--secondary button--filter",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeVersion(false))),
            disabled: _unref(store).mapVersion === false
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "icon icon--list" }, null, -1 /* HOISTED */)),
            _createElementVNode("span", null, "Listvy (" + _toDisplayString(_unref(store).numTotalResult) + ")", 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(ColumnSort, { radioName: "sort-by-stacked" }),
          _createVNode(ColumnPicker, {
            "id-prefix": "column-picker-stacked",
            columnConfig: _unref(columnConfig)
          }, null, 8 /* PROPS */, ["columnConfig"]),
          _createElementVNode("button", {
            class: "button button--filter download-result",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (saveToExcel(_unref(store).searchResult?.results)))
          }, _cache[7] || (_cache[7] = [
            _createElementVNode("span", null, "Ladda ner", -1 /* HOISTED */),
            _createElementVNode("span", { class: "icon icon--download" }, null, -1 /* HOISTED */)
          ]))
        ])
      ]),
      _createVNode(ResultTable),
      _createVNode(ResultCardList)
    ]),
    _createVNode(MapBox, { markers: geojson.value }, null, 8 /* PROPS */, ["markers"])
  ], 2 /* CLASS */))
}
}

})